import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import { getInlineEditableSaveFunction } from './product-groups-inline-edit';
import ViewModel from '../viewmodel/base-edit-bid-viewmodel';
import ClientLogger from '../../log/client-logger';

export class ProductGroupsEditBidBaseView extends Backbone.View {
  initialize({
    view,
    deps,
    model,
    bidProperty,
    validators,
    selectedItems = [],
    template,
    IsAutoBidding,
  } = {}) {
    this.isAutoBidding = IsAutoBidding;
    this.view = view;
    this.deps = deps;
    this.logger = new ClientLogger(this.deps.instrumentation);
    this.viewModel = new ViewModel({
      deps: this.deps,
      editSchema: this.genEditSchema(),
      model,
      bidProperty,
      validators,
    });

    this.selectedItems = selectedItems;
    this.template = template;
    this.bidProperty = bidProperty;
    this.on('cancel', () => {
      this.remove();
    });
  }

  render() {
    this.$el.html(this.template({
      i18n: this.deps.i18n,
      i18nGlobal: this.deps.i18nGlobal,
      bidProperty: this.bidProperty,
    }));

    ko.applyBindings(this.viewModel, this.el);
    this.validate();

    return this;
  }

  get events() {
    return {
      'click .save': 'save',
      'click .cancel': 'cancel',
    };
  }

  validate() {
    if (this.viewModel.IsExcluded() || this.isAutoBidding) { //eslint-disable-line
      return true;
    }

    const isValid = this.viewModel.validate();

    return _.isEmpty(this.viewModel.requiredMessage()) && isValid;
  }

  getErrors(data) {
    return _.reduce(data.Records, (memo, record) => {
      const errorMessages = _.chain(record.Errors)
        .pluck('Message')
        .flatten()
        .value();

      return _.extend(memo, {
        [record.Id]: errorMessages,
      });
    }, {});
  }

  save() {
    if (!this.validate()) {
      return;
    }

    getInlineEditableSaveFunction(this.deps)({
      view: this.view,
      i18n: this.deps.i18n,
      fieldName: this.getFieldName(),
      updated: this.getUpdated(),
      editorView: this,
      editorViewCallbackAfterUpdate: () => {
        this.trigger('close');
        this.logger.logChangeBidOrBidBoost({
          itemId: this.getUpdated().Id,
          updated: this.getUpdated(),
          level: this.view.level,
          isTreeView: this.view.isTreeView,
        });
      },
    });
  }

  setErrors(errorMapping) {
    this.viewModel.errors(_.values(errorMapping));
  }

  cancel() {
    this.trigger('cancel');
  }
}
